import { render, staticRenderFns } from "./InsuranceCompanyInfo.vue?vue&type=template&id=393c9793&"
import script from "./InsuranceCompanyInfo.vue?vue&type=script&lang=js&"
export * from "./InsuranceCompanyInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports